import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Job, { JobInfo } from "../../../../../components/job/Job";
import { MembersApiRoutes } from "../../../../../shared/api-routes/member/members-api.routes";
import http from "../../../../../shared/utils/http";
import "../job-timeline/JobTimeline.scss";
import "./MyJobs.scss";

const MyJobs: React.FC = () => {
	const params = useParams();
	const [jobs, setJobs] = useState<JobInfo[]>([]);
	const [cursor, setCursor] = useState<string | null>(null);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);
	const loaderRef = useRef<HTMLDivElement | null>(null);

	const onDeleteJob = (job_id: string) => {
		setJobs((prev) => prev.filter((item) => item.id !== job_id));
	};

	const loadMorePosts = async () => {
		if (loading || !hasMore) return;

		setLoading(true);
		const url = `${MembersApiRoutes.GET_USER_JOBS(params.userId)}?limit=10${
			cursor ? `&cursor=${cursor}` : ""
		}`;

		http.get(url).then((res) => {
			if (res.length === 0) {
				setHasMore(false);
			} else {
				setJobs((prev) => [...prev, ...res]);
				const lastJob = res[res.length - 1];
				setCursor(lastJob.createdAt);
			}
			setLoading(false);
		});
	};

	useEffect(() => {
		if (!loaderRef.current || !hasMore) return;

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting && !loading) {
					loadMorePosts();
				}
			},
			{
				rootMargin: "300px",
			}
		);

		observer.observe(loaderRef.current);

		return () => observer.disconnect();
	}, [loaderRef.current, hasMore, loading]);

	return (
		<div className="grand-container">
			<div className="job_timeline_container">
				<p className="jobs__caption">My Jobs</p>
				<div className="job-timeline board-container">
					{jobs.length > 0 ? (
						<>
							{jobs.map((job: JobInfo, index: number) => (
								<Job
									onDeleteJob={onDeleteJob}
									jobInfo={job}
									key={index}
								/>
							))}
						</>
					) : !loading ? (
						<div className="empty-state">
							<p className="empty-state__message">
								You haven't posted any job yet
							</p>
						</div>
					) : null}
				</div>
				{hasMore && (
					<div
						ref={loaderRef}
						style={{ height: "1px" }}
					/>
				)}
			</div>
		</div>
	);
};

export default MyJobs;
